import '../../components/app/common.scss';

function CustomButton({name, icon = undefined, onClick = () => {}}) {
    return (
        <div className='custom-button' onClick={onClick}>
            <div style={{ display: `inline-block` }}>{name}</div>
            {icon && icon}
        </div>
    );
}

export default CustomButton;